"use strict";

import {
    GET_AVAILABLE_PROJECTS,
    GET_PROJECTS_FOR_SINGLE_USER,
} from "../../ApiEndpoints";
import apiClient from "../../utils/apiClient";
import { postWithFirebaseAuth } from "../../utils/firebaseApiClient";

export const getProjectsForSingleUser = (payload, config) => (
    apiClient.post(GET_PROJECTS_FOR_SINGLE_USER, payload, config)
);

// The backend identifies the requester from the Firebase token, not the payload.
export const getAvailableProjects = (payload, config) => (
    postWithFirebaseAuth(GET_AVAILABLE_PROJECTS, payload, config)
);

export const getProjectById = (projectId) => (
    apiClient.get(`/api/projects/${projectId}`, {})
);
